export function daysUntil(fromDate: Date, toDate: Date): number {
	const diff = toDate.getTime() - fromDate.getTime();
	return Math.ceil(diff / (1000 * 60 * 60 * 24));
}
